function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M10 10.7526H16",
  strokeWidth: 1.5
}), /*#__PURE__*/React.createElement("line", {
  x1: 10.75,
  y1: 10,
  x2: 10.75,
  y2: 16,
  strokeWidth: 1.5
}), /*#__PURE__*/React.createElement("line", {
  x1: 29.2469,
  y1: 10,
  x2: 29.2469,
  y2: 16,
  strokeWidth: 1.5
}), /*#__PURE__*/React.createElement("line", {
  x1: 29.4974,
  y1: 10.75,
  x2: 23.4974,
  y2: 10.75,
  strokeWidth: 1.5
}), /*#__PURE__*/React.createElement("line", {
  x1: 30,
  y1: 29.2474,
  x2: 24,
  y2: 29.2474,
  strokeWidth: 1.5
}), /*#__PURE__*/React.createElement("line", {
  x1: 29.25,
  y1: 30,
  x2: 29.25,
  y2: 24,
  strokeWidth: 1.5
}), /*#__PURE__*/React.createElement("line", {
  x1: 10.7516,
  y1: 30,
  x2: 10.7516,
  y2: 24,
  strokeWidth: 1.5
}), /*#__PURE__*/React.createElement("line", {
  x1: 10.5095,
  y1: 29.25,
  x2: 16.5095,
  y2: 29.25,
  strokeWidth: 1.5
}));

var SvgIconCrop = function SvgIconCrop(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return _ref2;
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconCrop, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-crop.05bca225.svg";
export { ForwardRef as ReactComponent };